module.exports = __webpack_public_path__ + "img/logo_header.81932755.svg";